<template>
  <div>
    <div class="has-background-light">
      <div class="columns is-gapless">
        <div class="column is-3 is-border-right">
          <date-picker
            id="startDatePicker"
            :model="rawStartDate"
            :clearable="false"
            :field-class="'is-padding-left is-padding-right has-background-white-bis'"
            :input-class="'is-fullwidth is-borderless has-background-transparent'"
            @input="updateDateFilter({ start: $event })"></date-picker>
        </div>
        <div class="column is-3 is-border-right">
          <date-picker
            id="endDatePicker"
            :model="rawEndDate"
            :clearable="false"
            :field-class="'is-padding-left is-padding-right has-background-white-bis'"
            :input-class="'is-fullwidth is-borderless has-background-transparent'"
            @input="updateDateFilter({ end: $event })"></date-picker>
        </div>
        <div class="column is-3 is-padding-left is-padding-right has-background-white-bis">
          <div class="select is-fullwidth has-background-transparent">
            <select
              id="period"
              v-model="periodSelected"
              @change="updateDateFilter(periodSelected)"
              class="is-borderless is-shadowless">
              <option :value="null">
                Périodes
              </option>
              <option
                v-for="period in periodsDatas"
                :value="period"
                :key="'period' + period.value">
                {{ period.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="column is-3 is-padding-left is-padding-right has-background-white-bis is-border-left">
          <div class="select is-fullwidth has-background-transparent">
            <select
              id="reference"
              v-model="referenceSelected"
              @change="updateReference(referenceSelected)"
              class="is-borderless is-shadowless">
              <option :value="null">
                Reference
              </option>
              <option
                v-for="period in referenceDatas"
                :value="period"
                :key="'reference' + period.value">
                {{ period.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="column is-hidden-desktop-only is-hidden-widescreen-only is-border-left"></div>
      </div>
    </div>
    <div class="columns is-gapless is-multiline is-border-top">
      <div class="column is-padding is-4 is-border-right is-border--dashed columns is-gapless is-column is-space-between  is-marginless">
        <div class="has-text-grey">
          Nombre d'options
        </div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-3 has-text-weight-medium">
            {{ companyOptions.length }}
            <!-- <sup class="is-size-5">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup> -->
          </div>
          <!-- <div class="is-marginless is-size-5 has-text-success">
            <span>+ </span>2 987 €
          </div> -->
        </div>
      </div>
      <div class="column is-padding is-4 is-border-right is-border--dashed columns is-gapless is-column is-space-between  is-marginless">
        <div class="has-text-grey">
          Nombre de réservations
        </div>
        <div class="is-margin-top-large">
          <stat-value
            :value="totalSales.reservation_count"
            :difference-value="differences.reservation_count"
            :value-with-difference="true"></stat-value>
        </div>
      </div>
      <div class="column is-padding is-4 columns is-column is-space-between  is-marginless">
        <div class="has-text-grey">
          Nombre d'annulations
        </div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">
            {{ totalSales.canceled_count }}
          </div>
          <div class="is-marginless is-size-7 has-text-success">
&nbsp;
          </div>
        </div>
      </div>
      <div class="column is-padding is-4 is-border-top is-border-right is-border--dashed columns is-gapless is-column is-space-between  is-marginless">
        <div class="has-text-grey">
          Total com
        </div>
        <div class="is-margin-top-large">
          <stat-value
            :value="totalSales.CA_seller"
            :difference-value="differences.CA_seller"
            :euro="true"
            :value-with-difference="true"></stat-value>
        </div>
      </div>
      <div class="column is-padding is-4 is-border-top is-border-right is-border--dashed columns is-gapless is-column is-space-between  is-marginless">
        <div class="has-text-grey">
          Prix ventes moyen
        </div>
        <div class="is-margin-top-large">
          <stat-value
            :value="totalSales.avg_valid_sale_price"
            :difference-value="differences.avg_valid_sale_price"
            :euro="true"
            :value-with-difference="true"></stat-value>
        </div>
      </div>
      <div class="column is-padding is-4 columns is-gapless is-column is-space-between is-border-top is-border--dashed  is-marginless">
        <div class="has-text-grey">
          Nombre de ventes nettes
        </div>
        <div class="is-margin-top-large">
          <stat-value
            :value="totalSales.sold_count"
            :difference-value="differences.sold_count"
            :value-with-difference="true"></stat-value>
        </div>
      </div>
    </div>
    <div class="has-background-light is-padding-small"></div>
    <div class="has-background-white is-padding">
      <!-- <div class="title is-4">Évolution des ventes de la société</div> -->
      <stats-chart
        v-if="salesChartData"
        :entities="salesChartData"
        :chart-line-configs="salesChartConfigs"
        :start-date="rawStartDate"
        :end-date="rawEndDate"></stats-chart>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { uniqBy } from 'lodash'
import StatsMixins from '@/components/statistics/StatsMixins'

export default {
  name: 'CompanyStats',
  components: {
    StatValue: () => import('@/components/statistics/StatValue'),
    StatsChart: () => import('@/components/statistics/StatsChart')
  },
  mixins: [StatsMixins],
  props: {
    company: Object,
    companyOptions: Array
  },
  data () {
    return {
      rawStartDate: moment().startOf('year').toDate(),
      rawEndDate: moment().endOf('year').toDate(),
      filters: {
        status: []
      }
    }
  },
  computed: {
    statsDefaultParams () {
      return { account: [this.company.pk] }
    },
    salesChartConfigs () {
      return [
        { name: 'Pré-Réservations', key: 'prereservation_count', color: '#5cb4eb' },
        { name: 'Réservations', key: 'reservation_count', color: '#2666b4' },
        { name: 'Actes', key: 'sold_count', color: '#060811' },
        { name: 'Annulations', key: 'canceled_count', color: '#db534d', coloredBullet: true }
      ]
    },
    salesChartData () {
      let data = { ...this.allPeriod }
      this.statsSales.forEach(x => {
        let date = moment(x.pre_reservation_date)
        if (x.sale_date) date = moment(x.sale_date)
        else if (x.signature_date) date = moment(x.signature_date)
        let formatedDate = date.format('YYYY-MM')
        if (!(formatedDate in data)) {
          data[formatedDate] = {
            date: date.toDate(),
            sales: [x]
          }
        } else {
          data[formatedDate].sales.push(x)
        }
      })
      return Object.values(data).map(x => {
        return {
          date: x.date,
          canceled_count: uniqBy(x.sales, 'pk').filter(y => y.status === 'canceled').length,
          prereservation_count: uniqBy(x.sales, 'pk').filter(y => y.status === 'pre_reserved').length,
          reservation_count: uniqBy(x.sales, 'pk').filter(y => y.status === 'reserved').length,
          sold_count: uniqBy(x.sales, 'pk').filter(y => y.status === 'sold').length
        }
      }).sort((a, b) => {
        return moment(a.date).format('x') - moment(b.date).format('x')
      })
    },
    differences () {
      if (!this.totalReferenceSales) return {}
      return {
        valid_CA: (this.totalSales.valid_CA - this.totalReferenceSales.valid_CA) / this.totalReferenceSales.valid_CA * 100,
        CA: (this.totalSales.CA - this.totalReferenceSales.CA) / this.totalReferenceSales.valid_CA * 100,
        avg_sale_price: (this.totalSales.avg_sale_price - this.totalReferenceSales.avg_sale_price) / this.totalReferenceSales.avg_sale_price * 100,
        prereservation_count: (this.totalSales.prereservation_count - this.totalReferenceSales.prereservation_count) / this.totalReferenceSales.prereservation_count * 100,
        reservation_count: (this.totalSales.reservation_count - this.totalReferenceSales.reservation_count) / this.totalReferenceSales.reservation_count * 100,
        sold_count: (this.totalSales.sold_count - this.totalReferenceSales.sold_count) / this.totalReferenceSales.sold_count * 100,
        canceled_count: (this.totalSales.canceled_count - this.totalReferenceSales.canceled_count) / this.totalReferenceSales.canceled_count * 100
      }
    }
  },
  methods: {
    getStats () {
      // get period stats
      this.getStatsSales()
      // get reference stats
      this.referenceSelected = this.referenceDatas[0]
      this.getStatsSales(true)
    }
  }
}
</script>
